export function normalizeChatDate(value: any): any {
  if (!value || typeof value.seconds === 'number') return value;
  const date = new Date(value); const ms = date.getTime();
  return { seconds: Math.floor(ms / 1000), nanoseconds: (ms % 1000) * 1000000, toDate: () => date };
}
export function normalizeChat(value: any): any {
  if (!value) return value;
  return { ...value, dateCreated: normalizeChatDate(value.dateCreated), lastUpdated: normalizeChatDate(value.lastUpdated) };
}
export function mergeChatMessages(...lists: any[][]): any[] {
  const values = new Map<string, any>();
  lists.forEach(list => list.forEach(message => values.set(String(message.idChatMessage ?? message.id), message)));
  return [...values.values()].sort((a, b) => (a.dateCreated?.seconds - b.dateCreated?.seconds) || (a.dateCreated?.nanoseconds - b.dateCreated?.nanoseconds) || Number(a.idChatMessage) - Number(b.idChatMessage));
}

